<!-- 自定义积木弹框 -->
<template>
  <div class="def-block-content">
    <gat-popup
      :class="[
        'popup-create-block',
        popupActive === 'createBlock' ? 'on' : 'off',
      ]"
      :title="'自建新的积木'"
      :primary-button="'确定'"
      @cancel="cancelPopup('defBlock')"
      @confirm="confirmCreateNewBlock"
    >
      <template v-slot:content>
        <div class="create-block-content">
          <!-- svg图形 -->
          <block-svg
            v-model="paramArr"
            @getDefineLabelName="getDefineLabelName"
            @getDefineParamArr="getDefineParamArr"
          />
          <div class="add-params">
            <el-button
              @click="addParamsNum('paramText')"
              class="add-btn"
              type="primary"
            >
              添加参数
            </el-button>
            <el-button
              @click="addParamsNum('paramLabel')"
              class="add-btn"
              type="primary"
              >添加文本标签
            </el-button>
          </div>
        </div>
      </template>
    </gat-popup>
  </div>
</template>

<script>
import GatPopup from '@/components/common/GatPopup'
import blockSvg from '@/components/blocklyEditor/common/BlockSvg.vue'
export default {
  components: {
    GatPopup,
    blockSvg,
  },
  props: {
    popupActive: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      paramArr: [
        // {
        //   paramText: "text or number",
        //   textWidth: 80,
        //   attr: "paramLabel"
        // }
      ],
      newBLockInfo: {
        blockName: '',
        paramsList: [],
      },
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    getDefineLabelName(val) {
      this.newBLockInfo.blockName = val
    },
    getDefineParamArr(vals) {
      let paramArr = vals || this.paramArr
      let defParamsArr = []
      paramArr.forEach((item) => {
        if (item.attr === 'paramText') {
          defParamsArr.push(item)
        } else if (item.attr === 'paramLabel') {
          defParamsArr[defParamsArr.length - 1].paramLabel = item.paramText
        }
      })
      this.newBLockInfo.paramsList = defParamsArr
      // console.log('this.newBLockInfo', this.newBLockInfo)
    },
    //增加新建积木参数数量
    addParamsNum(attr) {
      let { paramArr } = this
      // 第一个参数为标签参数时则无效，直接返回
      if (paramArr.length === 0 && attr === 'paramLabel') return false
      paramArr.push({
        paramText: '',
        paramType: 'paramText',
        textWidth: 120,
        paramLabel: null,
        attr,
      })
      this.paramArr = paramArr
    },
    //确定新建积木--用户匹配代码的积木;
    confirmCreateNewBlock() {
      let newBLockInfo = this.newBLockInfo
      this.$emit('confirmCreateNewBlock', newBLockInfo)
    },
    cancelPopup() {
      this.$emit('cancelPopup')
    },
  },
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
.popup-create-block {
  &.off {
    display: none;
  }
  &.on {
    z-index: 99;
  }

  ::v-deep .popup-inner {
    width: 1000px;
    min-height: 600px;
    .popup-buttons {
      .el-button.primary {
        background-color: #4c88ff;
      }
    }
    .popup-content {
      width: 100%;
      height: 100%;
      padding: 0px;

      .create-block-content {
        width: 100%;
        height: 100%;
        margin: 20px auto;
        font-size: 10px;
        overflow: auto;
        .block-bg {
          width: 90%;
          height: 45%;
          // background: url("../../../public/images/block.png") no-repeat;
          background-size: 100% auto;
          background-position: 10% 20%;
          position: absolute;
          margin-left: 20px;
        }
        .block-name {
          width: 190px;
          height: auto;
          margin-left: 50px;
          transform: translateY(35px);
          .el-input {
            width: 100%;
          }
        }
        .params-wrap-list {
          width: 100%;
          height: 30%;
          font-size: 10px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .params-wrap {
            &:first-of-type {
              margin-left: 50px;
            }
            // margin-top: 45px;
            width: 200px;
            display: flex;
            justify-content: flex-start;
            align-content: center;
            align-items: center;
            margin-right: 15px;
            // transform: translateY(60px);
            .param-label {
              margin-right: 5px;
              margin-top: 0px;
            }
            .data-type {
              width: 7.5em;
            }
          }
        }
        .add-params {
          width: 100%;
          min-height: 200px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }
        .add-btn {
          margin-left: 35px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
